import React from 'react';
import './ConversationalSearchProgressBar.css';

const STEP_MAP = {
  genreCategory: 1,
  subgenreCategories: 2,
  thematicCategories: 3
};


const ConversationalSearchProgressBar = ({ step }) => {
  const progress = STEP_MAP[step] || 1;
  const percentage = ((progress) / 4) * 100;

  return (
    <div className="progress-container">
      <div
        className="progress-fill"
        style={{ width: `${percentage}%` }}
      />
    </div>
  );
};

export default ConversationalSearchProgressBar;